<template>
  <footer>
    <b-navbar toggleable="sm" type="light" variant="light" fixed="bottom" class="navbar-footer" >
      <b-navbar-brand href="#" @click="Goto('https://www.logivia.se')">
        <img
          class="navbar-brand-full"
          src="../assets/img/brand/logivialogga_transp_min.png"          
          alt="Logivia - Logistics. But Smarter."
        />
      </b-navbar-brand>
      <slot></slot>
      <div>
        <a href="#" @click="Goto('https://www.logivia.se')">
          <b style="color: #707d4b">Transplanet™</b>
        </a>
        <span class="ml-1">&copy; 2021 Logivia AB</span>
      </div>
      <b-navbar-nav>
        <b-nav-item>
          <a href="#" @click="GotoCredPage()">License & Credits</a>
        </b-nav-item>
        
      </b-navbar-nav>
      <div>
        

      </div>
      <div class="ml-auto">
        <span class="mr-1">Version</span>
        <a href="#" @click="Goto('https://www.logivia.se')">{{getSettings().version}}</a> {{getSettings().baseUrl}}
      </div>
    </b-navbar>    
    
  </footer>
</template>
<script>
import Vue from "vue";
import {Api} from "../lib/api";
import Settings from "../lib/settings";

export default Vue.extend({
  name: "footerbar",
  methods: {
    Goto(url) {
      window.open(url);
    },
    GotoCredPage() {
      const api = new Api();
      this.Goto(api.baseUrl+'/home/license');
    },
     getSettings() {
      return Settings;
    }
  }
});
</script>
<style scoped>
  .navbar-footer {
    height: 25px;
    font-size:  xx-small;    
  }
</style>